import { render, staticRenderFns } from "./principal-parts.vue?vue&type=template&id=04eaaf0b&"
import script from "./principal-parts.vue?vue&type=script&lang=js&"
export * from "./principal-parts.vue?vue&type=script&lang=js&"
import style0 from "./principal-parts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04eaaf0b')) {
      api.createRecord('04eaaf0b', component.options)
    } else {
      api.reload('04eaaf0b', component.options)
    }
    module.hot.accept("./principal-parts.vue?vue&type=template&id=04eaaf0b&", function () {
      api.rerender('04eaaf0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/morph-parts/principal-parts.vue"
export default component.exports